import { createApiRef } from '@backstage/core-plugin-api';
import type {
  GroupInput,
  PortalGroup,
} from '@internal/backstage-plugin-portalgroups-common';

export interface Permissions {
  read: boolean;
  create: boolean;
  update: boolean;
  delete: boolean;
}

export interface PortalgroupsApi {
  checkPermissions(): Promise<Permissions>;
  fetchMyGroups(): Promise<PortalGroup[]>;
  createGroup(input: GroupInput): Promise<PortalGroup>;
  updateGroup(input: GroupInput): Promise<PortalGroup>;
}

export const portalgroupsApiRef = createApiRef<PortalgroupsApi>({
  id: 'plugin.portalgroups.service',
});
